import styled from 'styled-components';
import { device } from '../../utils/styled-component-mixins';

const ResponsiveVideoWrapperStyled = styled.div`
  .video-wrapper {
    height: 0;
    margin-bottom: 4rem;
    position: relative;
    padding-bottom: 56.25%;

    @media ${device.desktop} {
      margin-bottom: 0;
    }

    iframe {
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
  }
`;

const ResponsiveVideoWrapper = (props) => {
  const { embedCode } = props;

  return (
    <ResponsiveVideoWrapperStyled>
      <div className="video-wrapper" dangerouslySetInnerHTML={{ __html: embedCode }}></div>
    </ResponsiveVideoWrapperStyled>
  );
};

export default ResponsiveVideoWrapper;
